import React from "react";

/**
 * Indian Tricolor stripe — used as a 3-pixel accent line under sections.
 * Tasteful, not festival-stock. Saffron-white-green band — same proportion
 * as the national flag. Used as a subtle "designed for India" cue.
 */
const TricolorAccent = ({ className = "" }) => (
  <div className={`flex h-[3px] w-full ${className}`} aria-hidden="true">
    <div className="flex-1 bg-[#FF9933]" />
    <div className="flex-1 bg-white" />
    <div className="flex-1 bg-[#138808]" />
  </div>
);

export default TricolorAccent;
